const trendFromPct = (pct) => (pct > 0 ? "up" : pct < 0 ? "down" : "neutral");
const n = (v) => (typeof v === "number" ? v : 0);
/** Map one API row to a Daily Update table row. */
export const mapDailyUpdateRow = (row) => {
    const commPct = n(row.day_commission_diff);
    const revPct = n(row.day_revenue_diff);
    const commission = {
        expected: n(row.expected_day_commission),
        days: n(row.day_commission),
        diff: { percentage: commPct, trend: trendFromPct(commPct) },
        avgDaily: n(row.avg_daily_commission),
    };
    const revenue = {
        expected: n(row.expected_day_revenue),
        days: n(row.day_revenue),
        diff: { percentage: revPct, trend: trendFromPct(revPct) },
        avgDaily: n(row.avg_daily_revenue),
    };
    return {
        id: row.client_id,
        client: row.client_name,
        clientLinked: true,
        am: (row.account_managers || []).map((am) => ({ name: am.name, initials: am.initials })),
        commission,
        revenue,
    };
};
export const mapDailyUpdateRows = (rows = []) => rows.map(mapDailyUpdateRow);
/** Map the API footer to the sticky "Total Summary" totals. */
export const mapDailyUpdateTotals = (footer) => {
    const commPct = footer && footer.day_commission_diff !== "" ? Number(footer.day_commission_diff) : 0;
    const revPct = footer && footer.day_revenue_diff !== "" ? Number(footer.day_revenue_diff) : 0;
    return {
        commission: {
            expected: n(footer?.expected_day_commission),
            days: n(footer?.day_commission),
            diff: { percentage: commPct, trend: trendFromPct(commPct) },
            avgDaily: n(footer?.avg_daily_commission),
        },
        revenue: {
            expected: n(footer?.expected_day_revenue),
            days: n(footer?.day_revenue),
            diff: { percentage: revPct, trend: trendFromPct(revPct) },
            avgDaily: n(footer?.avg_daily_revenue),
        },
    };
};
// ── Summary tab ────────────────────────────────────────────────
const makeDiff = (pct) => ({ percentage: pct, trend: trendFromPct(pct) });
// A dual-value cell: primary (selected month) + secondary (compare month) + % diff chip.
const dualCell = (primary, secondary, diffPct) => ({
    primary,
    secondary,
    diff: makeDiff(diffPct),
});
/** Map one Summary API row to a Summary table row. */
export const mapSummaryRow = (row) => {
    const cmp = row.compare_month ?? {};
    const cd = row.compare_diff ?? {};
    return {
        id: row.client_id,
        client: row.client_name,
        clientLinked: true,
        am: (row.account_managers || []).map((am) => ({ name: am.name, initials: am.initials })),
        initialProjected: dualCell(n(row.initial_projected_commission), n(cmp.initial_projected_commission), n(cd.initial_projected_commission)),
        actualProjected: dualCell(n(row.act_projected_commission), n(cmp.act_projected_commission), n(cd.act_projected_commission)),
        current: dualCell(n(row.current_commission), n(cmp.current_commission), n(cd.current_commission)),
        // Diff(%) shows the selected vs compare month's own Diff% figures side by side.
        diffPercent: {
            left: makeDiff(n(row.projected_commission_diff_per)),
            right: makeDiff(n(cmp.projected_commission_diff_per)),
        },
        diffAmount: dualCell(n(row.projected_commission_diff), n(cmp.projected_commission_diff), n(cd.projected_commission_diff)),
        daysCommission: n(row.day_commission),
    };
};
export const mapSummaryRows = (rows = []) => rows.map(mapSummaryRow);
/** Map the Summary API footer to the "Total Summary" totals. */
export const mapSummaryTotals = (footer) => {
    const cmp = footer?.compare_month ?? {};
    const cd = footer?.compare_diff ?? {};
    const num = (v) => (typeof v === "number" ? v : 0);
    return {
        initialProjected: dualCell(n(footer?.initial_projected_commission), n(cmp.initial_projected_commission), n(cd.initial_projected_commission)),
        actualProjected: dualCell(n(footer?.act_projected_commission), n(cmp.act_projected_commission), n(cd.act_projected_commission)),
        current: dualCell(n(footer?.current_commission), n(cmp.current_commission), n(cd.current_commission)),
        diffPercent: {
            left: makeDiff(num(footer?.projected_commission_diff_per)),
            right: makeDiff(num(cmp.projected_commission_diff_per)),
        },
        diffAmount: dualCell(n(footer?.projected_commission_diff), n(cmp.projected_commission_diff), n(cd.projected_commission_diff)),
        daysCommission: n(footer?.day_commission),
    };
};
